// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__16UnT","notes":"Notes_notes__3wxq-","note":"Notes_note__LMP1E","markdown":"Notes_markdown__2vql7"};